import React, { useState, useEffect, useContext } from 'react';
import LayautContext from 'Context/ContextLayaut';
import { makeStyles } from '@mui/styles';
import { colors, Slide, Stack, TextField } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { Tabla } from 'ui-component';
import Services from './ServiciosCurso';
import headers from './headers';

const useStyles = makeStyles((theme) => ({
    paper: {
        textAlign: 'center'
    }
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const ModalAsignarGrupo = ({ data }) => {
    const classes = useStyles();
    const services = Services();
    const context = useContext(LayautContext);

    const { control, register } = useFormContext();

    const [grupos, setGrupos] = useState([]);
    const [ctl, setCtl] = useState({ estatusGrupo: [] });

    let grupoSelected = [];

    useEffect(() => {
        services.getGruposSinAsignar(
            (ct) => {
                setGrupos(ct.grupo || []);
                setCtl({ ...ctl, estatusGrupo: ct.estatusGrupo });
            },
            { idCurso: data.idCurso }
        );
    }, []);

    return (
        <Stack spacing={2}>
            <TextField
                id="outlined-basic"
                multiline
                rows="2"
                label="Observaciones"
                variant="outlined"
                {...register('observaciones', { required: false })}
            />
            <Controller
                control={control}
                name="grupoSelected"
                render={({ field: { onChange } }) => (
                    <Tabla
                        rows={grupos}
                        columns={headers(null, ctl).asignarGrupoByCurso}
                        isSeleccionable={{
                            accion: (data, checked) => {
                                if (checked) {
                                    grupoSelected = [...grupoSelected, data];
                                } else {
                                    grupoSelected = grupoSelected.filter((grupo) => grupo.idGrupo != data.idGrupo);
                                }
                                onChange(grupoSelected);
                            },
                            accionAll: (checked) => {
                                grupoSelected = checked ? grupos : [];
                                onChange(grupoSelected);
                            }
                        }}
                        columnKey="idGrupo"
                    />
                )}
            />
        </Stack>
    );
};

export default ModalAsignarGrupo;
